module.exports = __webpack_public_path__ + "static/media/footer-logo.290b0447.svg";